import { render } from "./DateValue.vue?vue&type=template&id=b9d85abe&scoped=true"
import script from "./DateValue.vue?vue&type=script&lang=js"
export * from "./DateValue.vue?vue&type=script&lang=js"

import "./DateValue.vue?vue&type=style&index=0&id=b9d85abe&scoped=true&lang=css"

import exportComponent from "/Users/zvonkobiskup/Code/op3/wp-content/plugins/op-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9d85abe"]])

export default __exports__